export default function getAgeLabel(age) {
	const monthsLabel = age.months ? ` og ${age.months} mnd` : '';
	return `${age.years} år${monthsLabel}`;
}
